import React, {useEffect} from 'react';
import FullPageLoadingIndicator from "../components/FullPageLoadingIndicator";
import {useApiFetch} from "../components/Providers/OidcProvider";
import {apiEndpoint} from "../utils/api";
import {useAuth0} from "@auth0/auth0-react";

const SignOut = () => {
    const { logout } = useAuth0();
    const apiFetch = useApiFetch();

    useEffect( () => {
        const signOut = async () => {
            try {
                const url = new URL(`/v1/user/logout`, apiEndpoint);
                await apiFetch(url.toString());
            } catch (e) {
                console.error('error logging logout', e);
            }

            await logout();
        }

        signOut().catch(e => logout());
    }, [apiFetch]);

    return (
        <FullPageLoadingIndicator/>
    );
};

export default SignOut;
